module.exports = __webpack_public_path__ + "img/jiantou4.cc4fd052.png";